/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {declaration as ɵa} from './khao-sat-client.module';
export {KhaoSatClientRoutes as ɵb} from './khao-sat-client.routing';